<template>
  <AuthModal v-if="isOpen" />
</template>
<script setup lang="ts">
import { omit } from 'lodash-es'

const auth = useAuthStore()
const authFlow = useAuthFlow()
const user = useUserStore()
const tracking = useTracking()
const wishlistStore = useWishlistStore()
const wishlist = useWishlist()
const router = useRouter()
const route = useRoute()
const [isOpen, toggle] = useToggle()
const { buildWishlistUrl } = useURLs()

onMounted(async () => {
  authFlow.subscribe(handleAuthModalState)
  auth.watchLogoutStart()
  checkIfAuthRequired()
})

onUnmounted(async () => {
  authFlow.unsubscribe(handleAuthModalState)
  auth.watchLogoutStop()
})

async function handleAuthModalState(state: AuthState) {
  toggle(state.status)

  if (!state.status && auth.isAuthorized) {
    await auth.init(true)
    await user.load()

    if (state?.accomCode) {
      tracking.handlers?.wishlists.addPropertyRedirectSuccess(
        state.accomCode,
        state.authMethod,
      )
      wishlistStore.selectAccommodationToAdd(state?.accomCode)
      wishlist.toggle({ code: state?.accomCode }, true)
      authFlow.resetState()
      return
    }

    if (state?.target === 'wishlists') {
      authFlow.resetState()
      await navigateTo(buildWishlistUrl().toString(), { external: true })
      return
    }
  }

  if (!state.status) {
    authFlow.resetState()
  }
}

function checkIfAuthRequired() {
  if (!authFlow.currentState.value?.authRequired) return

  authFlow.toggle(true)
  router.replace({ query: omit(route.query, ['createAccount']) })
}
</script>
